import { UploadWorkerApi as d } from "@decentriq/uploader";
function p(i) {
  return new Worker(
    "" + new URL("../../../assets/uploadWorker-bzMT375-.js", import.meta.url).href,
    {
      type: "module",
      name: i?.name
    }
  );
}
let e = null, t = null;
const k = () => t ? Promise.resolve(t) : e || (e = new Promise((i, l) => {
  const r = new p({
    name: "upload-worker"
  }), u = 2e4, o = () => {
    r.removeEventListener("message", a), r.removeEventListener("error", s), clearTimeout(m);
  };
  function a(n) {
    n.data === "hello" ? (o(), t = new d(r), i(t)) : (o(), e = null, l(new Error(`Worker init failed, unexpected init message: ${n.data}`)));
  }
  function s(n) {
    o(), e = null, l(new Error(`Worker init failed: ${n.message}`));
  }
  r.addEventListener("message", a), r.addEventListener("error", s);
  const m = setTimeout(() => {
    o(), e = null, l(new Error("Worker init failed: timeout"));
  }, u);
}), e);
export {
  k as default
};
//# sourceMappingURL=uploadWorkerPromise.js.map
